import { useMemo, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useModal } from '@/context/ModalContext';
// [v3 FIX] Correct import path: @/hooks/useAnalytics (NOT @/context/AnalyticsProvider)
import { useAnalytics } from '@/hooks/useAnalytics';
import { useExitIntent, isExitIntentSuppressed } from '@/hooks/useExitIntent';
import { useUser } from '@/hooks/useUser';
import { trackEvent } from '@/services/analytics';
import { isTWA } from '../../utils/tvDetect';

const EXCLUDED_PATHS = ['/earn', '/ambassador', '/login', '/auth'];

export const ExitIntentDetector = () => {
  const { pathname } = useLocation();
  // [v2 FIX] activeModal is now exposed by useModal() (see ModalContext changes below)
  const { activeModal, openModal } = useModal();
  // consent is passed to isExitIntentSuppressed for consent-gated localStorage reads
  const { consent } = useAnalytics();

  const enabled = useMemo(() => {
    if (isTWA()) return false;
    // 1. Not suppressed by prior dismissal (consent-gated localStorage read, sessionStorage fallback)
    if (isExitIntentSuppressed(consent)) return false;
    // 2. Not an existing ambassador (sessionStorage, not localStorage)
    try {
      if (sessionStorage.getItem('indikin_is_ambassador') === 'true') return false;
    } catch { /* noop */ }
    // 3. Not on excluded pages
    if (EXCLUDED_PATHS.some(p => pathname.startsWith(p))) return false;
    // 4. No other modal currently open (prevents stacking with any modal, including cookie-related)
    if (activeModal) return false;

    return true;
  }, [pathname, activeModal, consent]);

  const { user } = useUser();
  const handleTrigger = useCallback(() => {
    trackEvent('exit_intent_shown');
    const isGuestDashboard = !user && pathname.startsWith('/dashboard');
    openModal('exitIntent', { isGuestDashboard });
  }, [openModal, user, pathname]);

  useExitIntent({ enabled, onTrigger: handleTrigger });

  return null; // Headless component
};
